export const chunkArray = <T>(arr: T[], chunkSize = 200): T[][] => {
  const chunks: T[][] = []

  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize)
    chunks.push(chunk)
  }

  return chunks
}
